import { NgModule } from "@angular/core";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { UiModule } from "./ui.module";
import { PdfViewerModule } from "ng2-pdf-viewer";

@NgModule({
    declarations: [PrivacyPolicyComponent],
    imports: [
    CommonModule,
    IonicModule,
    UiModule,
    PdfViewerModule
],
    exports: [PrivacyPolicyComponent]
})
export class PrivacyPolicyModule { }